
















import Vue from 'vue'

export default Vue.extend({
  name: 'license-requirements-block',
  props: {
    mech: {
      type: Object,
      required: true,
    },
    color: {
      type: String,
      required: false,
      default: 'primary',
    },
  },
})
